import * as PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import ReactQuill, { Quill } from 'react-quill';
import ImageResize from 'quill-image-resize';
import ImageUploader from 'quill-image-uploader';

import { utils as uploaderUtils } from 'modules/uploader';

import rule from './EditorInput.rule';

const AlignStyle = Quill.import('attributors/style/align');
const BackgroundStyle = Quill.import('attributors/style/background');
const ColorStyle = Quill.import('attributors/style/color');
const DirectionStyle = Quill.import('attributors/style/direction');
const FontStyle = Quill.import('attributors/style/font');
const SizeStyle = Quill.import('attributors/style/size');

Quill.register(AlignStyle, true);
Quill.register(BackgroundStyle, true);
Quill.register(ColorStyle, true);
Quill.register(DirectionStyle, true);
Quill.register(FontStyle, true);
Quill.register(SizeStyle, true);

Quill.register('modules/imageResize', ImageResize);
Quill.register('modules/imageUploader', ImageUploader);

const { uploadImage, createId, buildSource } = uploaderUtils;

const handleUpload = file => {
    const id = createId();
    return uploadImage(id, file).then(() => buildSource(id));
};

const modules = {
    toolbar: [
        [{ header: [1, 2, 3, false] }],
        [{ font: [] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ color: [] }, { background: [] }],
        [{ list: 'ordered' }, { list: 'bullet' }, { align: [] }],
        ['link', 'image'],

        ['clean'],
    ],
    imageResize: {
        modules: ['Resize'],
    },
    imageUploader: {
        upload: handleUpload,
    },
};

const EditorInput = ({ input: { value, onFocus, onChange, onBlur } }) => {
    const { css } = useFela();
    return (
        <div className={css(rule)}>
            <ReactQuill
                value={value}
                onFocus={onFocus}
                onChange={(content, delta, source, editor) => {
                    onChange(editor.getHTML());
                }}
                onBlur={(range, source, editor) => {
                    onBlur(editor.getHTML());
                }}
                modules={modules}
            />
        </div>
    );
};

EditorInput.propTypes = {
    input: PropTypes.shape({
        value: PropTypes.string,
        onChange: PropTypes.func,
        onFocus: PropTypes.func,
        onBlur: PropTypes.func,
    }).isRequired,
};

export default EditorInput;
